import React from "react";
import { useTranslation } from 'react-i18next';
import "./sec3.css";
import BookingHero from "../common/headsec";

import IM1 from "../../asserts/IM1.png";
import IM2 from "../../asserts/IM2.png";
import IM3 from "../../asserts/IM3.png";
import IM4 from "../../asserts/IM4.png";
import IM5 from "../../asserts/IM5.png";
import IM6 from "../../asserts/IM6.png";
import IM7 from "../../asserts/IM7.png";

import IMG from "../../asserts/sec3-img.png";
import Sec3Card from "../common/Sec3Card";

const Sec3 = () => {
    const { t } = useTranslation();
    return (
        <section className="sec3">

            <BookingHero
                t1={t('sec3_hero_tag')}
                t2={t('sec3_hero_t1')}
                t3={t('sec3_hero_t2')}
                text={t('sec3_hero_text')}
            />

            <div className="sec3-container">
                <div className="sec3-left">
                    <Sec3Card img={IM1} title={t('sec3_cat_concerts')} text={t('sec3_cat_concerts_text')} num="156" c="pink" />
                    <Sec3Card img={IM2} title={t('sec3_cat_comedy')} text={t('sec3_cat_comedy_text')} num="89" c="orange" />
                    <Sec3Card img={IM3} title={t('sec3_cat_theatre')} text={t('sec3_cat_theatre_text')} num="124" c="purple" />
                    <Sec3Card img={IM5} title={t('sec3_cat_workshops')} text={t('sec3_cat_workshops_text')} num="203" c="red" />
                    <Sec3Card img={IM4} title={t('sec3_cat_talks')} text={t('sec3_cat_talks_text')} num="67" c="blue" />

                    <Sec3Card img={IM6} title={t('sec3_cat_community')} text={t('sec3_cat_community_text')} num="178" c="green" />
                    <Sec3Card img={IM7} title={t('sec3_cat_volunteering')} text={t('sec3_cat_volunteering_text')} num="92" c="pink2" />
                    <img src={IMG} className="sec3-side-img" alt="" />
                </div>


            </div>
        </section>
    );
};

export default Sec3;